import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row"]

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.rowTargets.forEach((row) => {
      if (query === "") {
        row.style.display = ""
        return
      }

      const searchContent = (row.dataset.searchContent || "").toLowerCase()
      const isMatched = searchContent.includes(query)
      row.style.display = isMatched ? "" : "none"
    })
  }
}
